import { render, staticRenderFns } from "./start-reset-password.vue?vue&type=template&id=47bf9c67&scoped=true&"
import script from "./start-reset-password.vue?vue&type=script&lang=js&"
export * from "./start-reset-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf9c67",
  null
  
)

export default component.exports